export const enGb = {
  accountName: "Account Name",
  accountNumber: "Account Number",
  add: "Add",
  addTotalBalance: "Add total balance",
  amount: "Amount",
  amountRefundedAlready: "Amount refunded already",
  amountRequested: "Amount requested",
  application: "Application",
  backToAllTransactions: "Back to all transactions",
  bank: "Bank",
  bankResponses: "Bank responses",
  beneficiary: "Beneficiary",
  branch: "Branch",
  cancel: "Cancel",
  cancelUrl: "Cancel URL",
  checkout: "(Checkout)",
  clear: "Clear",
  clientError: "Client Error",
  completed: "Completed",
  confirmationCode: "Confirmation code",
  country: "Country",
  currency: "Currency",
  ccy: "CCY",
  customer: "Customer",
  customerMustHavePayByLinkProductFlagEnabled:
    "Customer must have Pay by Link product flag enabled to be selected",
  customerName: "Customer name",
  date: "Date (UTC)",
  delivered: "Delivered",
  details: "Details",
  deviceFingerprint: "Device fingerprint",
  download: "Download",
  email: "Email",
  enable2FA: "Enable 2FA",
  expiryDate: "Expiry Date",
  expiryDateTime: "Expiry Date & Time",
  expiryDateUTC: "Expiry Date (UTC)",
  failed: "Failed",
  failureUrl: "Failure URL",
  fromToExchangeRate: "{{from}}/{{to}} exchange rate",
  generateLink: "Generate Link",
  generatePayByLink: "Generate Pay by Link",
  generateReport: "Generate report",
  givenRefundCouldNotBeFound: "Given refund could not be found",
  givenTransactionCouldNotBeFound:
    "Given transaction could not be found. Make sure you are on correct mode (production/sandbox).",
  group: "Group",
  goBackToRefunds: "Go back to refunds",
  helpYourCustomerPayFaster:
    "Help your customer pay faster by pre-selecting country. This will allow us to display relevant banks available in this country on Volt Checkout.",
  httpCode: "HTTP Code",
  iban: "IBAN",
  id: "ID",
  ignore: "Ignore",
  inProgress: "In progress...",
  ip: "IP",
  isoCode: "ISO code",
  lastInstitutionError: "Last institution error",
  leadingToFailure: "Leading to failure",
  linkCouldNotBeGenerated:
    "Link could not be generated. Check the form for encountered problems.",
  linkWillExpire: "Link will expire at 23:59 UTC that day",
  merchant: "Merchant",
  name: "Name",
  networkError: "Network Error",
  noCorrespondingRefunds: "No corresponding refunds found for the transaction.",
  noRecords: "No records",
  noRefundsFound: "No refunds found",
  noRefundsHaveBeenIssued: "No refunds have been issued yet",
  noResults: "No Results",
  notifications: "Notifications",
  notificationsX: "Notifications ({{count}})",
  notificationResponse: "Notification Response",
  notAvailable: "Not Available",
  noTransactions: "No transactions",
  notReceived: "Not received",
  notSelected: "Not selected",
  notSent: "Not Sent",
  payByLink: "Pay by Link",
  payByLinkDetails: "Pay by Link Details",
  payByLinkHasBeenSuccessFullyGenerated:
    "Pay by Link has been successfully generated.",
  payer: "Payer",
  payment: "Payment",
  paymentAmountMustBeGreaterThan:
    "Payment amount must be greater than {{value}}",
  paymentAuthFailed: "Payment auth failed",
  paymentDeclined: "Payment declined",
  paymentExpired: "Payment expired",
  paymentFailed: "Payment failed",
  paymentHasBeenFullyRefunded:
    "Refund time period for this payment has been exceeded.",
  paymentNotReceived: "Payment not received",
  paymentNotRefunded: "Payment not refunded",
  paymentPending: "Payment pending",
  paymentProvider: "(Payment Provider)",
  paymentRefunded: "Payment refunded",
  paymentReceived: "Payment received",
  paymentRegistered: "Payment registered",
  payments: "Payments",
  paymentSuccess: "Payment success",
  paymentUnknown: "Payment unknown",
  payerReference: "Payer Reference",
  pending: "Pending",
  pendingUrl: "Pending URL",
  pix: "PIX",
  pleaseSelectApplication: "Please select application",
  provider: "Provider",
  providerDetailedStatus: "Provider detailed status",
  received: "Received",
  redirect: "Redirect",
  reference: "Reference",
  refund: "Refund",
  refundAmount: "Refund amount",
  refundAmountMustBe: "Refund amount must be greater than {{value}}",
  refundAmountRemaining: "Refund amount remaining",
  refundConfirmed: "Refund confirmed",
  refundDaysRemaining: "Refund days remaining",
  refundDetails: "Refund details",
  refundFailed: "Refund failed",
  refundedViaApi: "Refunded via API",
  refundId: "Refund ID",
  refundNotFound: "Refund not found",
  refundNotPossible:
    "Refund not possible, check your total available refund amount and try again",
  refunds: "Refunds",
  refundsWereNotActivatedForThisCustomer:
    "Refunds were not activated for this customer",
  refundTimePeriodForThisPayment:
    "Refund time period for this payment has been exceeded",
  refundTransaction: "Refund Transaction",
  refundValue: "Refund {{value}}",
  refundsAreNotAvailableUntil: "Refunds are unavailable until you activate 2FA",
  refundsRequested: "Refunds requested",
  refundValueAndLeftDays:
    "{{value}} available for refund, {{count}} day remaining.",
  refundValueAndLeftDays_plural:
    "{{value}} available for refund, {{count}} days remaining.",
  refundValueOverAvailable:
    "{{value}} over the available refund limit. Please recalculate. You have {{count}} day remaining to process this refund.",
  refundValueOverAvailable_plural:
    "{{value}} over the available refund limit. Please recalculate. You have {{count}} days remaining to process this refund.",
  reportIsBeingGenerated: "Report is being generated...",
  reports: "Reports",
  response: "Response",
  retry: "Retry",
  returnToTransactionsDetails: "Return to transaction details",
  requestedBy: "Requested by",
  requestedViaParentUser: "requested via parent’s user",
  seemsLikeYouDoNotHavePermissionToViewPayersBankDetails:
    "Seems like you don't have permission to view payer's bank details. Contact your administrator if you think there is an error.",
  selectAnApplication:
    "Select an application, so that we can send the shopper to the correct page, based on which of these states the payment results in.",
  serverError: "Server Error",
  setFiltersOnPayments:
    "Set filters on the payments so their total is lower or equal {{limit}}",
  settledAt: "Settled at",
  settlement: "Settlement",
  sorrySomethingWentWrong:
    "Sorry, something went wrong. Please try again later.",
  sortCode: "Sort Code",
  status: "Status",
  statusNewPayment: "New payment",
  statusCompleted: "Completed",
  statusSettled: "Settled",
  statusNotReceived: "Not received",
  statusReceived: "Received",
  statusApprovedByRisk: "Approved by risk",
  statusAdditionalAuthorizationRequired: "Additional authorization required",
  statusBankRedirect: "Bank redirect",
  statusAuthorizedByUser: "Authorized by user",
  statusDelayedAtBank: "Delayed at bank",
  statusRefusedByRisk: "Refused by risk",
  statusCancelledByUser: "Cancelled by user",
  statusFailed: "Failed",
  statusRefusedByBank: "Refused by bank",
  statusErrorAtBank: "Error at bank",
  statusAbandonedByUser: "Abandoned by user",
  statusUnknown: "Unknown",
  submitTheDetailsOfThePayment:
    "Submit the details of the payment you'd like to initiate and we'll validate that this is a payment we can support.",
  success: "Success",
  successUrl: "Success URL",
  test: "Test",
  thereAreNoNotifications:
    "There are no notifications for this transaction. If this doesn't seem right, please contact your implementation team.",
  timeoutError: "Timeout Error",
  timePeriodForRefundExceededDoTalkSupport:
    "Time period for the refund has been exceeded, do talk to your support team if you think there is an issue.",
  timePeriodForRefundExceededMaximumPeriod:
    "Time period for the refund has been exceeded. The maximum refund period is 365 days.",
  toContinueYouNeedToConfirm:
    "To continue you need to confirm your identity with your 2FA code.",
  tooManyRetries: "Too many retries",
  transactionDetails: "Transaction details",
  transactionInThisStatusCannotBeRefunded:
    "Transaction in this status cannot be refunded. Once it settles - you will have 365 days to issue a refund.",
  transactionNotFound: "Transaction not found",
  transactions: "Transactions",
  transferStatus: "Transfer status",
  transferType: "Transfer type",
  uniqueReference: "Unique Reference",
  view: "View",
  volt: "Volt",
  voltId: "Volt ID",
  voltConnect: "(Volt Connect)",
  weHaveAcceptedYourRefundRequest:
    "We have accepted your refund request. Please bear with us while it's processed.",
  weAreGatheringMoreInformationAboutThePayment:
    "We are gathering more information about the payment",
  weAreWaitingForYourFirstTransactions:
    "We’re waiting for your first transactions.",
  youCannotRequestMoreThan5Reports:
    "You cannot request more than 5 reports at the same time",
  youCurrentlyHaveGlobalFilterApplied:
    "You currently have a global filter applied that is limiting the customers you see. To view all customers, please clear the filter.",
  youDoNotHaveAnyRefunds:
    "You don't have any refunds right now, do talk to your system administrator if you think there is an issue or our support team.",
  youMustHavePermissionForViewingApplications:
    "You must have permission for viewing applications in order to generate a Pay by Link payment.",
};
